module.exports = __webpack_public_path__ + "img/no.a7eb5076.svg";